import React, { Fragment } from "react"
import NerdInfo from "../components/NerdInfo"

const Nerd = () => {
  return (
    <Fragment>
      <NerdInfo />
    </Fragment>
  )
}

export default Nerd
